import { Link, NavLink, matchPath, useLocation } from 'react-router-dom'
import { useContext } from 'react'
import { titleTabs } from './tabs'
import { EditorialTitleContext } from './titleContext'
import { manualHref } from './links'
import { tabsFor, useEditorialMe } from './me'

const focus = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-glow'

/** The per-title tab bar. Hidden on a single piece, which has its own top bar. */
export function TitleTabs({ basePath, publicationSlug }: { basePath: string; publicationSlug?: string }) {
  const { pathname } = useLocation()
  const me = useEditorialMe()
  const contextSlug = useContext(EditorialTitleContext)?.publicationSlug
  const slug = publicationSlug ?? contextSlug
  const tabs = titleTabs(slug)
  if (/\/pieces\/[^/]+/.test(pathname)) return null
  // The help link opens the manual at the tab on screen (the Start screen is under Desk's tabs but has its own section).
  const current = tabs.find((t) => matchPath({ path: t.to ? `${basePath}/${t.to}` : basePath, end: t.end }, pathname))
  const help = /\/start$/.test(pathname) ? 'start' : current?.help
  return (
    <nav aria-label="Title sections" className="mb-6 flex flex-wrap items-center gap-1 border-b border-ink-500 font-ui">
      {tabsFor(tabs, me.data).map((t) => (
        <NavLink
          key={t.label}
          to={t.to ? `${basePath}/${t.to}` : basePath}
          end={t.end}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-3 py-2 text-[14px] font-semibold ${focus} ${isActive ? 'border-amber-glow text-paper' : 'border-transparent text-paper-dim hover:text-paper'}`}
        >
          {t.label}
        </NavLink>
      ))}
      <Link to={manualHref(help)} className={`ml-auto px-3 py-2 text-[13px] font-semibold text-amber-glow underline underline-offset-2 hover:text-paper ${focus}`}>
        How this works
      </Link>
    </nav>
  )
}
